import React, { FC } from 'react'

import { PromoResponse } from '@/context/promo/types'
import { isDollarPromo, isPercentagePromo } from '@/utils'

import Banner from '../banner'

export interface PromoBannerProps {
    promo: PromoResponse
}

const PromoBanner: FC<PromoBannerProps> = ({ promo }) => {
    const isDollar = isDollarPromo(promo.amountType)
    const isPercent = isPercentagePromo(promo.amountType)

    const promoAmount = isPercent ? `${promo.amount}%` : `$${promo.amount}`

    let subText = ''
    if (isPercent && Boolean(promo.maxAmount)) {
        subText = `(up to $${promo.maxAmount} per order)`
    } else if (isDollar && Boolean(promo.minTotal)) {
        subText = `($${promo.minTotal} min order)`
    }

    const content = `${promoAmount} off applied in Checkout ${subText}`

    return <Banner type="promo">{content}</Banner>
}

export default PromoBanner
